var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head",attrs:{"id":"head"}},[_c('div',{staticClass:"head-left",on:{"click":_vm.goBack}},[_c('a',{staticClass:"hym-head-left"})]),_vm._v(" "),_c('div',{staticClass:"head-title"},[_vm._v(_vm._s(_vm.vuetiltle))]),_vm._v(" "),_c('div',{staticClass:"head-right"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-65fe47e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/head-back-app.vue
// module id = null
// module chunks = 